import { EventDispatcher } from "../events/EventDispatcher";
import { Event } from "../events/Event";
import { GearDisplay } from "./gear/GearDisplay";
export class Controller extends EventDispatcher {
    constructor() {
        super();
        this.name = "";
        this._pages = [];
        this._selectedIndex = -1;
        this._previousIndex = -1;
        this._refs = new Set();
    }
    get pages() {
        return this._pages;
    }
    set pages(value) {
        this._pages = value;
        if (value.length > 0 && this._selectedIndex == -1)
            this.selectedIndex = 0;
    }
    get numPages() {
        return this._pages.length;
    }
    set numPages(value) {
        this._pages.length = value;
        for (let i = 0; i < value; i++)
            if (this._pages[i] == null)
                this._pages[i] = "";
    }
    addPage(name) {
        name = name || "";
        this._pages.push(name);
        if (this._selectedIndex == -1)
            this.selectedIndex = 0;
        return this;
    }
    get selectedIndex() {
        return this._selectedIndex;
    }
    set selectedIndex(value) {
        if (this._pages.length == 0)
            return;
        if (this._selectedIndex != value) {
            if (value > this._pages.length - 1) {
                console.warn(`index out of bounds: ${value}`);
                return;
            }
            this._previousIndex = this._selectedIndex;
            this._selectedIndex = value;
            this.changing = true;
            try {
                for (let ref of this._refs) {
                    ref.onChanged(this);
                }
                GearDisplay.checkAll(this);
                this.event(Event.CHANGED);
            }
            finally {
                this.changing = false;
            }
        }
    }
    get selectedPage() {
        if (this._selectedIndex < 0 || this._selectedIndex >= this._pages.length)
            return null;
        else
            return this._pages[this._selectedIndex];
    }
    set selectedPage(value) {
        let i = this._pages.indexOf(value);
        if (i === -1)
            i = 0;
        this.selectedIndex = i;
    }
    get previousIndex() {
        return this._previousIndex;
    }
    set oppositeIndex(value) {
        if (value > 0)
            this.selectedIndex = 0;
        else if (this._pages.length > 1)
            this.selectedIndex = 1;
    }
}
